/* PB LIGHT SWEEP engine (PB-1151, PB-1170, PB-1176), for sections/pb-light-sweep.liquid.
   The scene is pinned with position:sticky on a tall track. Everything is scrubbed by scroll (no timers):
   - A..B: the night layer wipes up from the bottom (the layer moves up while its contents move down by the same
     amount, so the light never moves). The sign's glow rises with the wipe and the dimmer over the night photo
     fades out with it. No flicker.
   - Tiny spark drawings (the business card sparkle plus the original star, sparkle and plus whims, from the
     sprite in snippets/pb-light-sweep-sparks.liquid) are scattered evenly over the whole dark area, loosely like
     the business cards. Once the dark has risen past the sign and the spark's own spot, they glow in where they
     sit, one or two at a time: each grows from 60% and fades in with a brief soft halo that settles, drifting a
     tiny way outward from the sign as it does (6 to 10% of its distance to the sign, max 24 px, 14 px on phones).
     Scrubbed by scroll, eased out, no overshoot, no spin, no trail. They stay settled.
     Kept clear of the heading, the header, the sticky add to cart bar, the sign face, the edges and each other.
     No streaks, no lines from the sign.
   Scrolling back reverses all of it. Reduced motion: not pinned, lit night with every spark shown.
   Sparks are placed here (seeded per section, so the same every visit) to fit the real section size.
   Transform/opacity only, one rAF per scroll. Adds no page-level state. */
(function () {
  if (window.__pblsBoot) { window.__pblsBoot(); return; }
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var A = 0.04, B = 0.62;                 /* track fractions: the wipe; hold the lit night (sparks shown) after B */
  var NS = 'http://www.w3.org/2000/svg';
  /* sprite symbols: name, width / height of the viewBox, how often (weights) */
  var SHAPES = [['card', 435.095 / 334.383, 0.5], ['sparkle', 67.7063 / 85.98, 0.2], ['star', 57.1683 / 66.4833, 0.17], ['plus', 38.6772 / 45.0811, 0.13]];

  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function rng(seed) { var s = seed >>> 0 || 1; return function () { s ^= s << 13; s >>>= 0; s ^= s >> 17; s ^= s << 5; s >>>= 0; return s / 4294967296; }; }
  function hash(str) { var h = 2166136261; for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function el(tag, attrs) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }

  function boot(root) {
    if (root.__pbls) return;
    var track = root.querySelector('[data-track]'), scene = root.querySelector('[data-scene]');
    var night = root.querySelector('[data-night]'), inner = root.querySelector('[data-night-in]');
    if (!track || !scene || !night || !inner) return;
    root.__pbls = 1;
    var off = root.querySelector('.pbls__off');
    var photo = inner.querySelector('.pbls__photo'), copy = inner.querySelector('.pbls__copy');
    var fx = parseFloat(root.getAttribute('data-fx')) || 51, fy = parseFloat(root.getAttribute('data-fy')) || 47;
    /* PB-1176 [src M-1D86]: find the lit sign in the night photo itself (the product photos are framed differently:
       sign left, right, round, tall), then centre both photos on it at one size (radius T of the photo box), so the
       feather, the halo and the sparks' keep-clear ring all sit on the real sign. The photos are same-origin
       (pinbuds.com/cdn), so a small canvas can read them. If that fails the old focus/zoom settings are used. */
    /* draw a photo into an N x N canvas as object-fit: cover does. The whole image is the source (no source crop):
       with srcset, naturalWidth is density-corrected while drawImage's source rect is in bitmap pixels */
    function cover(x, img, N) {
      var r = img.naturalWidth / img.naturalHeight, w = r >= 1 ? N * r : N, h = r >= 1 ? N : N / r;
      x.drawImage(img, (N - w) / 2, (N - h) / 2, w, h);
    }
    function edgeColour(img) {   /* median colour of a photo's outer edge, so the section can match it exactly */
      try {
        var N = 48, cv = document.createElement('canvas'); cv.width = cv.height = N;
        var x = cv.getContext('2d', { willReadFrequently: true });
        cover(x, img, N);
        var d = x.getImageData(0, 0, N, N).data, ch = [[], [], []];
        for (var i = 0; i < N * N; i++) { var px = i % N, py = (i / N) | 0; if (px < 2 || py < 2 || px > N - 3 || py > N - 3) for (var c = 0; c < 3; c++) ch[c].push(d[i * 4 + c]); }
        return 'rgb(' + ch.map(function (a) { a.sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }).join(',') + ')';
      } catch (e) { return ''; }
    }
    var sign = null, T = 0.155;   /* sign half-size as a share of the photo box (the box is 1.3x the old one) */
    function findSign() {
      if (sign) return false;
      var img = photo.querySelector('img');
      if (!img || !img.complete || !img.naturalWidth) return false;
      try {
        var N = 96, cv = document.createElement('canvas'); cv.width = cv.height = N;
        var cx2 = cv.getContext('2d', { willReadFrequently: true });
        cover(cx2, img, N);   /* same centre crop as object-fit: cover */
        var d = cx2.getImageData(0, 0, N, N).data, L = [], mx = 0, bd = [], i;
        for (i = 0; i < N * N; i++) {
          var l = (0.2126 * d[i * 4] + 0.7152 * d[i * 4 + 1] + 0.0722 * d[i * 4 + 2]) / 255, px = i % N, py = (i / N) | 0;
          L.push(l); if (l > mx) mx = l;
          if (!px || !py || px === N - 1 || py === N - 1) bd.push(l);
        }
        bd.sort(function (a, b) { return a - b; });
        mx = L.slice().sort(function (a, b) { return a - b; })[Math.floor(L.length * 0.99)];   /* robust top: ignores a glint */
        var bg = bd[bd.length >> 1], t = bg + (mx - bg) * 0.55, xs = [], ys = [];
        if (mx - bg < 0.2) return false;
        for (i = 0; i < N * N; i++) if (L[i] > t) { xs.push(i % N); ys.push((i / N) | 0); }
        if (xs.length < 30) return false;
        xs.sort(function (a, b) { return a - b; }); ys.sort(function (a, b) { return a - b; });
        var q = function (a, f) { return a[Math.floor(f * (a.length - 1))]; };
        var x0 = q(xs, 0.03) / N, x1 = (q(xs, 0.97) + 1) / N, y0 = q(ys, 0.03) / N, y1 = (q(ys, 0.97) + 1) / N;
        var hw = (x1 - x0) / 2, hh = (y1 - y0) / 2, sc = Math.max(0.5, Math.min(2.6, T / Math.max(hw, hh)));
        /* round or square? just inside the bounding box corners a square sign is still lit, a round one is not */
        var cs = 0, cn = 0;
        [[x0, y0], [x1, y0], [x0, y1], [x1, y1]].forEach(function (c) {
          var px = Math.round((c[0] + (c[0] < 0.5 * (x0 + x1) ? 1 : -1) * hw * 0.16) * N), py = Math.round((c[1] + (c[1] < 0.5 * (y0 + y1) ? 1 : -1) * hh * 0.16) * N);
          if (px >= 0 && py >= 0 && px < N && py < N) { cs += L[py * N + px] > t ? 1 : 0; cn++; }
        });
        sign = { cx: (x0 + x1) / 2, cy: (y0 + y1) / 2, hw: hw * sc, hh: hh * sc, s: sc, round: cn ? cs / cn < 0.5 : true };
      } catch (e) { return false; }
      root.style.setProperty('--pimg', 'translate(' + ((0.5 - sign.s * sign.cx) * 100).toFixed(2) + '%,' + ((0.5 - sign.s * sign.cy) * 100).toFixed(2) + '%) scale(' + sign.s.toFixed(4) + ')');
      makeHaze();
      root.style.setProperty('--night', edgeColour(img));   /* the dark around the sign = the night photo's own background */
      var dimg = root.querySelector('.pbls__layer--day .pbls__photo img');
      var dayBg = function () { var c = edgeColour(dimg); if (c) root.style.setProperty('--day', c); };
      if (dimg) { if (dimg.complete && dimg.naturalWidth) dayBg(); else { dimg.loading = 'eager'; dimg.addEventListener('load', dayBg); } }
      root.classList.add('has-sign');
      root._pblsSign = sign;
      builtW = 0;
      return true;
    }
    
    /* the light on and around the sign (PB-1176, src M-A66F, M-AA68): ONE layer, drawn here to the sign's own shape.
       Over the sign face a flat, even warm haze (no hot spot, no darker rim); from the sign's edge outward the same
       haze fades smoothly to nothing (no ring, no second band). Dithered, so it never bands. */
    var haze = root.querySelector('.pbls__haze');
    function makeHaze() {
      if (!haze || !sign) return;
      var S = 480, cv = document.createElement('canvas'); cv.width = cv.height = S;
      var x = cv.getContext('2d'), im = x.createImageData(S, S), d = im.data;
      var hw = sign.hw, hh = sign.hh, rr = Math.min(hw, hh) * 0.16, A0 = 0.14, LL = 0.085, col = [255, 214, 158];
      for (var j = 0; j < S; j++) for (var i = 0; i < S; i++) {
        var dx = Math.abs(((i + 0.5) / S - 0.5) * 1.7), dy = Math.abs(((j + 0.5) / S - 0.5) * 1.7), dist;   /* canvas = 1.7x the box */
        if (sign.round) dist = (Math.hypot(dx / hw, dy / hh) - 1) * Math.min(hw, hh);
        else { var qx = dx - hw + rr, qy = dy - hh + rr; dist = Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) + Math.min(Math.max(qx, qy), 0) - rr; }
        var a = dist <= 0 ? A0 : A0 * (0.55 * Math.exp(-Math.pow(dist / LL, 1.2)) + 0.45 * Math.exp(-Math.pow(dist / 0.3, 1.1))), o = (j * S + i) * 4;   /* near bloom + long soft tail, same level at the edge */
        d[o] = col[0]; d[o + 1] = col[1]; d[o + 2] = col[2];
        d[o + 3] = Math.max(0, Math.min(255, Math.round(a * 255 + Math.random() - 0.5)));   /* dither */
      }
      x.putImageData(im, 0, 0);
      cv.className = 'pbls__haze-c';
      haze.textContent = ''; haze.appendChild(cv);
    }

    var seed = hash(root.id || 'pbls'), sid = root.id.replace(/^pbls-/, '');
    var svg = null, sparks = [], builtW = 0, builtH = 0;

    function pick(R) { var r = R(), i = 0; while (i < SHAPES.length - 1 && (r -= SHAPES[i][2]) > 0) i++; return SHAPES[i]; }
    function build() {
      var W = inner.clientWidth, H = inner.clientHeight;
      if (!W || !H || (W === builtW && Math.abs(H - builtH) < 2 && svg)) return;
      builtW = W; builtH = H;
      if (svg) svg.remove();
      var R = rng(seed);
      var ir = inner.getBoundingClientRect(), pr = photo.getBoundingClientRect();
      var C = sign ? [pr.left - ir.left + pr.width / 2, pr.top - ir.top + pr.height / 2] : [pr.left - ir.left + pr.width * fx / 100, pr.top - ir.top + pr.height * fy / 100];
      var mob = W < 750;
      var zoom = parseFloat(root.getAttribute(mob ? 'data-zoom-m' : 'data-zoom')) || 1.8;
      var r0 = sign ? Math.hypot(sign.hw, sign.hh) * pr.width * 0.92 : Math.min(pr.width, pr.height) * 0.25 * zoom;   /* the sign (fallback: the recropped photos, sign about half the frame) */
      var cb = copy ? copy.getBoundingClientRect() : null, cT = -1e4, cB = -1e4, cL = 0, cR = 0;
      if (cb && cb.height) {   /* the heading block, trimmed to the text itself */
        var kids = [].slice.call(copy.children), l = 1e4, r = -1e4;
        kids.forEach(function (c) { var b = c.getBoundingClientRect(); if (b.width) { l = Math.min(l, b.left); r = Math.max(r, b.right); } });
        cT = cb.top - ir.top; cB = cb.bottom - ir.top; cL = (kids.length ? l : cb.left) - ir.left; cR = (kids.length ? r : cb.right) - ir.left;
      }
      var hh = parseFloat(getComputedStyle(root).getPropertyValue('--ab-header-h')) || 64;
      var edge = mob ? 36 : 48, top = hh + 10, bot = H - (mob ? 140 : 100);   /* clear of the side quiz tab and the sticky add to cart bar */
      var N = Math.max(10, Math.min(28, Math.round(W * H / (mob ? 23000 : 50000))));   /* evenly sprinkled, no bare patches */
      var lo = mob ? 15 : 22, hi = mob ? 34 : 54;                     /* spark width in px, like the cards: mostly small */
      function free(x, y, rad) {
        if (x - rad < edge || x + rad > W - edge || y - rad < top || y + rad > bot) return false;
        if (y - rad < cB + 12 && y + rad > cT - 12 && x + rad > cL - 16 && x - rad < cR + 16) return false;
        if (Math.hypot(x - C[0], y - C[1]) < r0 * 1.15 + rad) return false;
        return true;
      }
      var placed = [];
      for (var n = 0; n < N; n++) {   /* best candidate: of 30 free spots, keep the one furthest from the others */
        var sh = pick(R), u = R(), w = lo + (hi - lo) * u * u * (n === 0 || n === 5 ? 1 : 0.7), rad = Math.max(w, w / sh[1]) / 2;
        var best = null, bestD = -1;
        for (var c = 0; c < 30; c++) {
          var x = edge + R() * (W - 2 * edge), y = top + R() * (bot - top);
          if (!free(x, y, rad)) continue;
          var dmin = 1e9;
          for (var j = 0; j < placed.length; j++) dmin = Math.min(dmin, Math.hypot(x - placed[j].x, y - placed[j].y) - placed[j].rad - rad);
          if (dmin < 10) continue;
          if (dmin > bestD) { bestD = dmin; best = { x: x, y: y }; }
        }
        if (best) placed.push({ x: best.x, y: best.y, rad: rad, w: w, sh: sh, rot: (sh[0] === 'card' ? 14 : 30) * (R() - 0.5) * 2 });
      }
      svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('class', 'pbls__sparks'); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('width', W); svg.setAttribute('height', H); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
      sparks = [];
      /* timing on the whole track p (0..1): each spark glows in just behind the rising dark edge, as soon as the edge
         has passed its own spot (about 3% of the section higher), so the dark fills with sparks as it rises */
      var wp = function (k) { return A + k * (B - A); }, du = 0.045;
      var defs = document.createElementNS(NS, 'defs');   /* one shared soft halo: warm yellow, fading to nothing */
      defs.innerHTML = '<radialGradient id="pbls-halo-' + sid + '"><stop offset="0" stop-color="#F4F7B0" stop-opacity=".9"/><stop offset=".35" stop-color="#E2ED65" stop-opacity=".35"/><stop offset="1" stop-color="#E2ED65" stop-opacity="0"/></radialGradient>';
      svg.appendChild(defs);
      var startAt = placed.map(function (p) { return wp(cl(1 - (p.y - p.rad) / H + 0.03)); });
      placed.forEach(function (p, pi) {
        var g = document.createElementNS(NS, 'g'), use = document.createElementNS(NS, 'use'), h = p.w / p.sh[1];
        g.setAttribute('class', 'pbls__spark');
        use.setAttribute('href', '#pbls-' + p.sh[0] + '-' + sid);
        use.setAttribute('x', (-p.w / 2).toFixed(1)); use.setAttribute('y', (-h / 2).toFixed(1));
        use.setAttribute('width', p.w.toFixed(1)); use.setAttribute('height', h.toFixed(1));
        var halo = document.createElementNS(NS, 'circle');   /* the soft glow behind it, only while it lights up */
        halo.setAttribute('r', (Math.max(p.w, h) * 0.75).toFixed(1)); halo.setAttribute('fill', 'url(#pbls-halo-' + sid + ')'); halo.setAttribute('opacity', '0');
        g.appendChild(halo); g.appendChild(use); svg.appendChild(g);
        /* a tiny drift: it starts a little nearer the sign (6 to 10% of the way, capped) and eases out to its spot */
        var dx = p.x - C[0], dy = p.y - C[1], dist = Math.hypot(dx, dy) || 1, pull = Math.min(dist * (0.06 + 0.04 * R()), mob ? 14 : 24);
        sparks.push({ g: g, halo: halo, x: p.x, y: p.y, x0: p.x - dx / dist * pull, y0: p.y - dy / dist * pull, rot: p.rot, s: startAt[pi], dur: du, last: -1 });
      });
      inner.appendChild(svg);
      lastK = -1; lastP = -1;
    }
    function setSparks(p) {   /* p = track progress; 1 = everything settled */
      for (var i = 0; i < sparks.length; i++) {
        var sp = sparks[i], t = Math.round(cl((p - sp.s) / sp.dur) * 300) / 300;
        if (t === sp.last) continue;
        sp.last = t;
        var e = 1 - Math.pow(1 - t, 3);                         /* eases out, settles, no overshoot */
        var x = sp.x0 + (sp.x - sp.x0) * e, y = sp.y0 + (sp.y - sp.y0) * e;
        sp.g.setAttribute('opacity', (t ? cl(e * 1.5) : 0).toFixed(3));
        sp.halo.setAttribute('opacity', (0.7 * Math.sin(Math.PI * t)).toFixed(3));   /* glows up, then settles away */
        sp.g.setAttribute('transform', 'translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ') rotate(' + sp.rot.toFixed(0) + ') scale(' + (0.6 + 0.4 * e).toFixed(3) + ')');
      }
    }

    var nightImg = photo.querySelector('img');
    if (RM) {   /* static: lit night, every spark shown */
      var go = function () { findSign(); build(); setSparks(1); };
      go(); addEventListener('load', go);
      if (nightImg) nightImg.addEventListener('load', go);
      addEventListener('resize', function () { if (inner.clientWidth !== builtW) go(); }, { passive: true });
      return;
    }
    root.classList.add('is-live');
    var total = 1, H = 1, vw = 0, vh = 0, near = false, raf = false, lastY = -1, lastK = -1, lastP = -1;

    function measure() {
      findSign();
      vw = innerWidth; vh = innerHeight;
      H = scene.offsetHeight || vh;
      total = Math.max(1, track.offsetHeight - H);
      lastY = -1; lastK = -1; lastP = -1;
      var y0 = night.style.transform, y1 = inner.style.transform;
      night.style.transform = inner.style.transform = 'none';   /* measure the scene untransformed */
      build();
      night.style.transform = y0; inner.style.transform = y1;
    }
    function frame() {
      raf = false;
      var r = track.getBoundingClientRect();
      var p = cl(-r.top / total);
      var k = cl((p - A) / (B - A));
      var y = Math.round((1 - k) * H);
      if (y !== lastY) {
        lastY = y;
        night.style.transform = 'translate3d(0,' + y + 'px,0)';
        inner.style.transform = 'translate3d(0,' + (-y) + 'px,0)';
      }
      var kr = Math.round(k * 400) / 400;
      if (kr !== lastK) {
        lastK = kr;
        if (off) off.style.opacity = (0.82 * (1 - kr)).toFixed(3);
        var g = kr * kr * (3 - 2 * kr);
        if (haze) haze.style.opacity = g.toFixed(3);
      }
      var pr = Math.round(p * 1200) / 1200;
      if (pr !== lastP) { lastP = pr; setSparks(pr); }
      root._pblsK = k; root._pblsP = p;
    }
    function kick() { if (!raf) { raf = true; requestAnimationFrame(frame); } }
    function onResize() { if (innerWidth === vw && Math.abs(innerHeight - vh) <= 150) return; measure(); kick(); }

    measure(); frame();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) kick(); }, { rootMargin: '50% 0px 50% 0px' }).observe(root);
    } else near = true;
    addEventListener('scroll', function () { if (near) kick(); }, { passive: true });
    addEventListener('resize', onResize, { passive: true });
    addEventListener('load', function () { measure(); kick(); });
    if (nightImg) nightImg.addEventListener('load', function () { if (findSign()) { measure(); kick(); } });
    addEventListener('pageshow', function () { measure(); kick(); });
  }
  function bootAll() { [].forEach.call(document.querySelectorAll('[data-pbls]'), boot); }
  window.__pblsBoot = bootAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
